import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { Paragraph2, SVG } from "../../components";
import { BackLinkStyled } from "./styled";

const BackLink = ({ to, onClick, children }) => {
  return (
    <BackLinkStyled>
      {to ? (
        <Link to={to}>
          <SVG.BackArrowIcon />
          <Paragraph2>{children}</Paragraph2>
        </Link>
      ) : onClick ? (
        <button onClick={onClick}>
          <SVG.BackArrowIcon />
          <Paragraph2>{children}</Paragraph2>
        </button>
      ) : null}
    </BackLinkStyled>
  );
};

BackLink.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.string.isRequired
};

export default BackLink;
